// extracted by mini-css-extract-plugin
export default {"mark":"ProbableOfferMark_mark__Aq-1I"};